<template>
    <section class="rtb-form-section">
        <div class="rtb-form-section__row">
            <div class="field" data-field="start_date">
                <label class="field__label" for="rtb-form-start">Дата начала</label>
                <input
                    id="rtb-form-start"
                    v-model="form.start_date"
                    type="date"
                    class="form-input"
                    :min="isEdit ? undefined : today"
                    :disabled="disabled || startLocked"
                    :class="{ 'is-invalid': errors.start_date }"
                    @change="emit('dates-change')"
                />
                <p v-if="startLocked" class="field__hint">Дата начала недоступна: показы уже начались</p>
                <p v-if="errors.start_date" class="field__error">{{ errors.start_date }}</p>
            </div>
            <div class="field" data-field="end_date">
                <label class="field__label" for="rtb-form-end">Дата окончания</label>
                <input
                    id="rtb-form-end"
                    v-model="form.end_date"
                    type="date"
                    class="form-input"
                    :min="endMin"
                    :disabled="disabled"
                    :class="{ 'is-invalid': errors.end_date }"
                    @change="emit('dates-change')"
                />
                <p v-if="errors.end_date" class="field__error">{{ errors.end_date }}</p>
            </div>
        </div>

        <fieldset class="rtb-form-fieldset">
            <legend>Расписание</legend>
            <p class="field__hint">Дни и часы, когда кампания участвует в аукционе.</p>
            <slot name="schedule" />
        </fieldset>
    </section>
</template>

<script setup>
defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    today: { type: String, required: true },
    startLocked: { type: Boolean, default: false },
    endMin: { type: String, default: '' },
});

const emit = defineEmits(['dates-change']);
</script>
